import styled from 'styled-components';

import { Button, Typography } from '@speeki/global-ui-components';

import { maxWidth } from '@utils/helpers';

export const UnavailableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 458px;

    ${maxWidth('md')} {
        margin: 0 auto;
        max-width: unset;
    }
`;

export const Title = styled(Typography.TextH3_24_34)`
    margin-bottom: 24px;

    ${maxWidth('md')} {
        text-align: center;
    }
`;

export const Description = styled(Typography.TextBody_16_24)`
    margin-bottom: 40px;

    ${maxWidth('md')} {
        text-align: center;
    }
`;

export const UnavailableButton = styled(Button)`
    align-self: flex-start;

    ${maxWidth('md')} {
        width: 100%;
    }
`;
